import { useState } from 'react';
import { Col, Row, Card, Button } from 'react-bootstrap';
import './l75hmi.css';
import dayjs from 'dayjs';

const L75Hmi = ({ machineLive = {} }) => {
  const [page, setPage] = useState('HOME');

  const renderPage = () => {
    switch (page) {
      case 'E75':
        return <L75ExtruderPage machineLive={machineLive} setPage={setPage} />;
      case 'E45':
        return <L45ExtruderPage machineLive={machineLive} setPage={setPage} />;
      case 'E75Color':
        return <E75ColorPage machineLive={machineLive} setPage={setPage} />;
      case 'E45Color':
        return <E45ColorPage machineLive={machineLive} setPage={setPage} />;
      case 'MeterPage':
        return <L75MeterPage machineLive={machineLive} setPage={setPage} />;
      case 'HOME':
      default:
        return <L75HmiHome machineLive={machineLive} setPage={setPage} />;
    }
  };
  return <>{renderPage()}</>;
};
const E45ColorPage = ({ machineLive = {}, setPage }) => {
  const extruderYield = machineLive.e45ExtruderYield || {
    PVC: 2.368,
    XLPE: 2.05,
    HFFR: 2.124
  };

  const colorYield = machineLive.e45ColorYield || {
    BLACK: 0.4166,
    RED: 0.4026,
    YELLOW: 0.4231,
    BLUE: 0.3999,
    GREEN: 0.4165,
    CATELYSER: 0.2457,
    GX: 0
  };

  return (
    <div className="color-page-container">
      {/* TITLE */}
      <div className="color-title">E45 COLOR</div>

      <Row className="g-4">
        {/* LEFT – TABLE */}
        <Col md={4}>
          <div className="card-modern">
            {/* EXTRUDER YIELD */}
            <div className="table-block">
              <div className="table-title">E45 EXTRUDER YIELD (kg/min)</div>

              {Object.entries(extruderYield).map(([k, v]) => (
                <div key={k} className="table-row">
                  <span>{k}</span>
                  <span>{v}</span>
                </div>
              ))}
            </div>

            <hr />

            {/* COLOR YIELD */}
            <div className="table-block">
              <div className="table-title">E45 COLOR YIELD (kg/min)</div>

              {Object.entries(colorYield).map(([k, v]) => (
                <div key={k} className="table-row">
                  <span>{k}</span>
                  <span>{v}</span>
                </div>
              ))}
            </div>
          </div>
        </Col>

        {/* CENTER – MACHINE */}
        <Col md={4} className="text-center">
          <div className="color-machine-holder">
            <div className="machine-drawer">COLOR MACHINE</div>

            <div className="small-extruder">E45</div>

            <div className="yield-box set">
              YIELD %100 &nbsp; {machineLive.e45YieldSet || '1.000'} kg/min
            </div>

            <div className="yield-box act">
              ACTUAL YIELD &nbsp; {machineLive.e45YieldAct || '0.001'} kg/min
            </div>
          </div>
        </Col>

        {/* RIGHT – CONTROL */}
        <Col md={4}>
          <div className="card-modern">
            <div className="right-switch">
              <div
                className={`switch-knob ${
                  machineLive.e45ColorOn ? 'on' : 'off'
                }`}
              >
                {machineLive.e45ColorOn ? 'ON' : 'OFF'}
              </div>
            </div>

            <div className="yield-box set">
              COLOR YIELD (%100) &nbsp; {machineLive.e45ColorYield || '0.600'}{' '}
              kg/min
            </div>

            <div className="yield-box set">
              RATIO (%) &nbsp; {machineLive.e45ColorRatio || '0.6'} %
            </div>

            <div className="yield-box act">
              ACTUAL YIELD &nbsp; {machineLive.e45ActualOutput || '0.0000'}{' '}
              kg/min
            </div>
          </div>

          {/* TEST */}
          <div className="color-test">
            <Button className="color-test-btn">COLOR YIELD TEST</Button>
          </div>
        </Col>
      </Row>
      <div className="l75-menu mt-3">
        {['🏠', 'E75', 'E45', 'E75 COLOR PAGE', 'E45 COLOR PAGE', '🛠', '⚠'].map(
          (i, idx) => (
            <Button
              key={idx}
              onClick={() => {
                if (i === '🏠') setPage('HOME');
                if (i === 'E75') setPage('E75');
                if (i === 'E45') setPage('E45');
                if (i === 'E75 COLOR PAGE') setPage('E75Color');
                if (i === 'E45 COLOR PAGE') setPage('E45Color');
                if (i === '🛠') setPage('MeterPage');
              }}
              className={`menu-icon ${i === '⚠' ? 'warn' : ''}`}
            >
              {i}
            </Button>
          )
        )}
      </div>
    </div>
  );
};

const L75MeterPage = ({ machineLive = {}, setPage }) => {
  return (
    <div className="extruder-container">
      {/* HOME */}

      <Row className="g-3">
        {/* ───────── METER ───────── */}
        <Col md={4}>
          <Card className="card-modern">
            <div className="panel-title">METER</div>

            <div className="yield-box set">
              SET &nbsp; {machineLive.meterSet || '100000.0'} m
            </div>

            <div className="yield-box act">
              ACTUAL &nbsp; {machineLive.METER_ACT || '0.3'} m
            </div>

            <div className="yield-box set">
              CAPSTAN COEFF. &nbsp; {machineLive.capstanCoeff || '1.000'}
            </div>

            <div className="yield-box set">
              CATERPILLAR COEFF. &nbsp;{' '}
              {machineLive.caterpillarCoeff || '1.000'}
            </div>

            <Button className="w-100 mt-2 btn-warning">
              ACTUAL METER RESET
            </Button>
          </Card>
        </Col>

        {/* ───────── METER SELECTION ───────── */}
        <Col md={4}>
          <Card className="card-modern text-center">
            <div className="panel-title">METER SELECTION</div>
            <div className="panel-sub">Line Stop & Alarm</div>

            <Button className="stop-btn my-2">STOP</Button>

            <div className="yield-box act">
              TOTAL &nbsp; {machineLive.meterTotal || '76288.5'} m
            </div>

            <Button className="w-100 btn-secondary">TOTAL METER RESET</Button>
          </Card>
        </Col>

        {/* ───────── PAY OFF DANCER ───────── */}
        <Col md={2}>
          <Card className="card-modern">
            <div className="panel-title">PAY OFF DANCER</div>

            <div className="yield-box set">
              SET &nbsp; {machineLive.payoffSet || '50.0'}
            </div>

            <div className="yield-box set">
              GAIN &nbsp; {machineLive.payoffGain || '0.087'}
            </div>

            <div className="yield-box set">
              INTEG &nbsp; {machineLive.payoffInteg || '2.8'}
            </div>

            <div className="yield-box act">
              ACT POS &nbsp; {machineLive.payoffPos || '96.2'}
            </div>
          </Card>
        </Col>

        {/* ───────── TAKE UP DANCER ───────── */}
        <Col md={2}>
          <Card className="card-modern">
            <div className="panel-title">TAKE UP DANCER</div>

            <div className="yield-box set">
              SET &nbsp; {machineLive.takeupSet || '40.0'}
            </div>

            <div className="yield-box set">
              GAIN &nbsp; {machineLive.takeupGain || '0.5'}
            </div>

            <div className="yield-box set">
              INTEG &nbsp; {machineLive.takeupInteg || '1.5'}
            </div>

            <div className="yield-box act">
              ACT POS &nbsp; {machineLive.takeupPos || '39.8'}
            </div>
          </Card>
        </Col>
      </Row>
      <div className="l75-menu mt-3">
        {['🏠', 'E75', 'E45', 'E75 COLOR PAGE', 'E45 COLOR PAGE', '🛠', '⚠'].map(
          (i, idx) => (
            <Button
              key={idx}
              onClick={() => {
                if (i === '🏠') setPage('HOME');
                if (i === 'E75') setPage('E75');
                if (i === 'E45') setPage('E45');
                if (i === 'E75 COLOR PAGE') setPage('E75Color');
                if (i === 'E45 COLOR PAGE') setPage('E45Color');
                if (i === '🛠') setPage('MeterPage');
              }}
              className={`menu-icon ${i === '⚠' ? 'warn' : ''}`}
            >
              {i}
            </Button>
          )
        )}
      </div>
    </div>
  );
};

const E75ColorPage = ({ machineLive = {}, setPage }) => {
  const extruderYield = machineLive.extruderYield || {
    PVC: 8.33,
    XLPE: 6.989,
    HFFR: 7.989
  };

  const colorYield = machineLive.colorYield || {
    BLACK: 0.4166,
    RED: 0.4026,
    YELLOW: 0.4231,
    BLUE: 0.3999,
    GREEN: 0.4165,
    CATELYSER: 0.2457
  };

  return (
    <div className="color-page-container">
      {/* HOME BUTTON */}

      {/* TITLE */}
      <div className="color-title">E75 COLOR</div>

      <Row className="g-4">
        {/* LEFT TABLE */}
        <Col md={4}>
          <div className="card-modern">
            <div className="table-block">
              <div className="table-title">E75 EXTRUDER YIELD (kg/min)</div>

              {Object.entries(extruderYield).map(([k, v]) => (
                <div key={k} className="table-row">
                  <span>{k}</span>
                  <span>{v}</span>
                </div>
              ))}
            </div>

            <hr />

            <div className="table-block">
              <div className="table-title">E75 COLOR YIELD (kg/min)</div>

              {Object.entries(colorYield).map(([k, v]) => (
                <div key={k} className="table-row">
                  <span>{k}</span>
                  <span>{v}</span>
                </div>
              ))}
            </div>
          </div>
        </Col>

        {/* CENTER IMAGE */}
        <Col md={4} className="text-center">
          <div className="color-machine-holder">
            <div className="machine-drawer">COLOR MACHINE</div>

            <div className="small-extruder">E75</div>

            <div className="yield-box set">
              YIELD %100 &nbsp; {machineLive.extruderYieldSet || '7.000'} kg/min
            </div>

            <div className="yield-box act">
              ACTUAL YIELD &nbsp; {machineLive.extruderYieldAct || '0.043'}{' '}
              kg/min
            </div>
          </div>
        </Col>

        {/* RIGHT SIDE */}
        <Col md={4}>
          {/* SWITCH */}
          <div className="card-modern">
            <div className="right-switch">
              <div
                className={`switch-knob ${machineLive.colorOn ? 'on' : 'off'}`}
              >
                {machineLive.colorOn ? 'ON' : 'OFF'}
              </div>
            </div>

            <div className="yield-box set">
              COLOR YIELD (%100) &nbsp; {machineLive.colorYield || '0.600'}{' '}
              kg/min
            </div>

            <div className="yield-box set">
              RATIO (%) &nbsp; {machineLive.colorRatio || '0.600'} %
            </div>

            <div className="yield-box act">
              ACTUAL OUTPUT &nbsp; {machineLive.actualOutput || '0.0000'} kg/min
            </div>
          </div>

          {/* TEST BUTTON */}
          <div className="color-test">
            <Button className="color-test-btn">COLOR YIELD TEST</Button>
          </div>
        </Col>
      </Row>

      <div className="l75-menu mt-3">
        {['🏠', 'E75', 'E45', 'E75 COLOR PAGE', 'E45 COLOR PAGE', '🛠', '⚠'].map(
          (i, idx) => (
            <Button
              key={idx}
              onClick={() => {
                if (i === '🏠') setPage('HOME');
                if (i === 'E75') setPage('E75');
                if (i === 'E45') setPage('E45');
                if (i === 'E75 COLOR PAGE') setPage('E75Color');
                if (i === 'E45 COLOR PAGE') setPage('E45Color');
                if (i === '🛠') setPage('MeterPage');
              }}
              className={`menu-icon ${i === '⚠' ? 'warn' : ''}`}
            >
              {i}
            </Button>
          )
        )}
      </div>
    </div>
  );
};

const L45ExtruderPage = ({ machineLive = {}, setPage }) => {
  const zonesSet = [
    'E45_Zone1TempSetValue',
    'E45_Zone2TempSetValue',
    'E45_Zone3TempSetValue',
    'E45_ClampTempSetValue',
    'E45_AdaptorTempSetValue'
  ];
  const zonesAct = [
    'E45_Zone1ActualTempValue',
    'E45_Zone2ActualTempValue',
    'E45_Zone3ActualTempValue',
    'E45_ClampActualTempValue',
    'E45_AdaptorActualTempValue'
  ];

  return (
    <div className="extruder-container">
      {/* ───────── TOP STATUS BAR ───────── */}
      <Row className="g-3 mb-3">
        <Col md={4}>
          <div className="status-card warning">
            <div className="status-title">ALARM TEMPERATURE DEVIATION</div>
            <div className="status-value">
              {machineLive.E45_TempDeviationValue || '10'} °C
            </div>
          </div>
        </Col>

        <Col md={4}>
          <div className="status-card success">ZONE TEMPERATURE READY</div>
          <div className="status-card success mt-2">HEAD TEMPERATURE READY</div>
        </Col>

        <Col md={4}>
          <div className="status-card success">
            ZONES (1–3) HEATER / FAN START
          </div>
          <div className="status-card success mt-2">
            CLAMP / ADAPTOR HEATER START
          </div>
        </Col>
      </Row>

      {/* ───────── MAIN BODY ───────── */}
      <Row className="g-4">
        {/* LEFT COLUMN */}
        <Col md={2}>
          <div className="card-modern">
            <div className="left-title">SCREW RPM</div>
            <div className="left-big">
              {machineLive.E45_MotorRpmValue || '0.0'} RPM
            </div>

            <hr />

            <div className="left-title">MOTOR CURRENT</div>
            <div className="left-big">
              {machineLive.E45_MotorCurrentValue || '0.0'} A
            </div>
          </div>
        </Col>

        {/* CENTER */}
        <Col md={7}>
          <div className="card-modern extruder-box">
            {/* HEADER */}
            <div className="extruder-header">
              <div
                className={`extruder-status ${
                  machineLive.E45_ExtruderOnOff ? 'on' : 'off'
                }`}
              >
                E45 {machineLive.E45_ExtruderOnOff ? 'ON' : 'OFF'}
              </div>

              <div className="extruder-percent">
                {machineLive.extruderPercent || '14.0'} %
              </div>
            </div>

            {/* SCHEMA */}
            <div className="extruder-image-placeholder">L45 EXTRUDER</div>

            {/* ZONE TABLE */}
            <div className="zones-table mt-3">
              {/* SET */}
              <div className="zones-row title-row">
                <div className="cell title">SET</div>
                {zonesSet.map((z, i) => (
                  <div key={i} className="cell set">
                    {machineLive[z]}
                  </div>
                ))}
              </div>

              {/* ACT */}
              <div className="zones-row">
                <div className="cell title">ACT</div>
                {zonesAct.map((z, i) => (
                  <div key={i} className="cell act">
                    {machineLive[z]}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Col>

        {/* RIGHT COLUMN */}
        <Col md={3}>
          {/* EXTRUDER YIELD */}
          <div className="card-modern">
            <div className="right-title">EXTRUDER YIELD</div>

            <div className="yield-box set">
              YIELD (%100) &nbsp;{' '}
              {machineLive.E45_EXTRUDER_YIELD_PVC || '1.000'} kg/min
            </div>

            <div className="yield-box act">
              ACTUAL YIELD &nbsp;{' '}
              {machineLive.E45_EXTRUDER_ACTUAL_YIELD_PLC || '0.001'} kg/min
            </div>

            <div className="right-status off">E45 YIELD CONTROL</div>
          </div>
        </Col>
      </Row>
      <div className="l75-menu mt-3">
        {['🏠', 'E75', 'E45', 'E75 COLOR PAGE', 'E45 COLOR PAGE', '🛠', '⚠'].map(
          (i, idx) => (
            <Button
              key={idx}
              onClick={() => {
                if (i === '🏠') setPage('HOME');
                if (i === 'E75') setPage('E75');
                if (i === 'E45') setPage('E45');
                if (i === 'E75 COLOR PAGE') setPage('E75Color');
                if (i === 'E45 COLOR PAGE') setPage('E45Color');
                if (i === '🛠') setPage('MeterPage');
              }}
              className={`menu-icon ${i === '⚠' ? 'warn' : ''}`}
            >
              {i}
            </Button>
          )
        )}
      </div>
    </div>
  );
};

const L75ExtruderPage = ({ machineLive = {}, setPage }) => {
  const zonesSet = [
    'E75_Zone1TempSetValue',
    'E75_Zone2TempSetValue',
    'E75_Zone3TempSetValue',
    'E75_Zone4TempSetValue',
    'E75_ClampTempSetValue',
    'E75_AdaptorTempSetValue',
    'E75_Head1TempSetValue',
    'E75_Head2TempSetValue'
  ];

  const zonesAct = [
    'E75_Zone1ActualTempValue',
    'E75_Zone2ActualTempValue',
    'E75_Zone3ActualTempValue',
    'E75_Zone4ActualTempValue',
    'E75_ClampActualTempValue',
    'E75_AdaptorActualTempValue',
    'E75_Head1ActualTempValue',
    'E75_Head2ActualTempValue'
  ];

  return (
    <div className="extruder-container">
      {/* ───────── TOP STATUS BAR ───────── */}
      <Row className="g-3 mb-4">
        <Col md={4}>
          <div className="status-card warning">
            <div className="status-title">ALARM TEMP DEVIATION</div>
            <div className="status-value">
              {machineLive.E75_TempDeviationValue || '20'} °C
            </div>
          </div>
        </Col>

        <Col md={4}>
          <div className="status-card">
            <div className="status-title">TEMP TOLERANCE</div>
            <div className="status-value">
              {machineLive.E75_WaitingTempValue || '2'} °C
            </div>
          </div>
        </Col>

        <Col md={4}>
          <div className="status-card">
            <div className="status-title">HEAD TEMP READY</div>
            <div
              className={`status-value ${
                machineLive.headReady ? 'green' : 'red'
              }`}
            >
              {machineLive.headReady ? 'READY' : 'NOT READY'}
            </div>
          </div>
        </Col>
      </Row>

      {/* ───────── MAIN BODY ───────── */}
      <Row className="g-4">
        {/* LEFT COLUMN */}
        <Col md={2}>
          <div className="card-modern">
            <div className="left-title">SCREW RPM</div>
            <div className="left-big">
              {machineLive.E75_ScrewRpmValue.toFixed(2) || '0.0'} RPM
            </div>

            <hr />

            <div className="left-title">MOTOR CURRENT</div>
            <div className="left-big green">
              {machineLive.E75_MotorCurrentValue.toFixed(2) || '0.0'} A
            </div>
          </div>

          <div className="card-modern mt-3">
            <div className="right-title">EXTRUDER YIELD</div>

            <div className="yield-box set">
              YIELD (Q/10) &nbsp;{' '}
              {machineLive.E75_EXTRUDER_YIELD_PVC.toFixed(2) || '7.000'} kg/min
            </div>

            <div className="yield-box act">
              ACTUAL YIELD &nbsp;{' '}
              {machineLive.E75_EXTRUDER_ACTUAL_YIELD_PLC.toFixed(2) || '0.043'}{' '}
              kg/min
            </div>
          </div>
        </Col>

        {/* CENTER */}
        <Col md={7}>
          <div className="card-modern extruder-box">
            {/* HEADER */}
            <div className="extruder-header">
              <div
                className={`extruder-status ${
                  machineLive.E75_ExtruderOnOff ? 'on' : 'off'
                }`}
              >
                E75 {machineLive.E75_ExtruderOnOff ? 'ON' : 'OFF'}
              </div>

              <div className="extruder-percent">
                {machineLive.E75_PercentReferenceValue || '46.0'} %
              </div>
            </div>

            {/* SCHEMA ZONA EXTRUDER */}
            <div className="extruder-image-placeholder">L75 EXTRUDER</div>

            {/* TABLE ZONE TEMPERATURE */}
            <div className="zones-table mt-3">
              {/* SET */}
              <div className="zones-row title-row">
                <div className="cell title">SET</div>
                {zonesSet.map((z, i) => (
                  <div key={i} className="cell set">
                    {machineLive[z]}
                  </div>
                ))}
              </div>

              {/* ACT */}
              <div className="zones-row">
                <div className="cell title">ACT</div>
                {zonesAct.map((z, i) => (
                  <div key={i} className="cell act">
                    {machineLive[z]}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Col>

        {/* RIGHT COLUMN */}
        <Col md={3}>
          <div className="card-modern">
            <div className="right-title">CONTROL</div>

            <div className="right-set-value">
              {machineLive.E75_PercentReferenceValue || '52.0'}
            </div>

            <div className="right-arrows">
              <button className="arrow-btn">▲</button>
              <button className="arrow-btn">▼</button>
            </div>

            <div
              className={`right-status ${
                machineLive.E75_ExtruderOnOff ? 'on' : 'off'
              }`}
            >
              {machineLive.E75_ExtruderOnOff ? 'RUNNING' : 'STOPPED'}
            </div>
          </div>
        </Col>
      </Row>
      <div className="l75-menu mt-3">
        {['🏠', 'E75', 'E45', 'E75 COLOR PAGE', 'E45 COLOR PAGE', '🛠', '⚠'].map(
          (i, idx) => (
            <Button
              key={idx}
              onClick={() => {
                if (i === '🏠') setPage('HOME');
                if (i === 'E75') setPage('E75');
                if (i === 'E45') setPage('E45');
                if (i === 'E75 COLOR PAGE') setPage('E75Color');
                if (i === 'E45 COLOR PAGE') setPage('E45Color');
                if (i === '🛠') setPage('MeterPage');
              }}
              className={`menu-icon ${i === '⚠' ? 'warn' : ''}`}
            >
              {i}
            </Button>
          )
        )}
      </div>
    </div>
  );
};
const L75HmiHome = ({ machineLive = {}, setPage }) => {
  const now = dayjs();

  return (
    <div className="l75-hmi">
      {/* ================= TOP BAR ================= */}
      <Row className="g-2 mb-2 align-items-stretch">
        <Col md={3}>
          <Card className="top-card h-100">
            <Card.Body>
              <div className="top-label">DATE / TIME</div>
              <div className="top-date-value">
                {now.format('DD.MM.YYYY')}
                <br />
                {now.format('HH:mm:ss')}
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={5}>
          <Card className="top-card text-center live-speed h-100">
            <Card.Body className="d-flex flex-column justify-content-center">
              <div className="top-label">LINE SPEED</div>
              <div className="top-speed-value">
                {machineLive.LineSpeed.toFixed(2) || '0.0'}
                <span className="speed-unit"> m/min</span>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={4}>
          <Card className="top-card meters h-100">
            <Card.Body className="d-flex flex-column justify-content-center">
              <div className="meter-row set">
                SET{' '}
                <span>
                  {machineLive.MeterSetValue.toFixed(2) || '100000'} m
                </span>
              </div>
              <div className="meter-row act mt-1">
                ACT <span>{machineLive.METER_ACT.toFixed(2) || '0'} m</span>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* ================= MID ZONE ================= */}
      <Row className="g-2">
        {/* = MASTER BAR = */}
        <Col md={4}>
          <Card className="panel master-panel h-100">
            <Row className="h-100">
              <Col
                xs={4}
                className="d-flex flex-column justify-content-between"
              >
                <div className="master-box yellow">
                  MIN
                  <br />
                  <b>{machineLive.MasterMaximumValue || '1.0'}</b>
                </div>

                <div className="master-box active">
                  ACT
                  <br />
                  <b>{machineLive.MazterActualValue || '1.0'}</b>
                </div>

                <div className="master-box yellow">
                  MAX
                  <br />
                  <b>{machineLive.MasterMaximumValue || '100.0'}</b>
                </div>
              </Col>

              <Col
                xs={8}
                className="d-flex flex-column align-items-center justify-content-center"
              >
                <div className="gauge-title">MASTER SPEED</div>

                <div className="gauge-wrapper">
                  <div className="gauge-bar-bg"></div>
                  <div
                    className="gauge-bar-fill"
                    style={{ height: `${machineLive.MazterActualValue || 0}%` }}
                  ></div>
                </div>

                <div className="gauge-value">
                  {machineLive.gaugeValue || '0.0'}
                </div>
              </Col>
            </Row>
          </Card>
        </Col>

        {/* = CAPSTAN ZONE = */}
        <Col md={3}>
          <Card className="panel h-100 d-flex flex-column justify-content-between">
            <div className="panel-header d-flex justify-content-between align-items-center">
              CAPSTAN
              <div
                className={`bootstrap-switch ${
                  machineLive.CapstanSelect ? 'on' : 'off'
                }`}
              >
                {machineLive.CapstanSelect ? 'ON' : 'OFF'}
              </div>
            </div>

            <div className="capstan-body text-center">
              <div className="capstan-value">
                {machineLive.CapstanPercenRef.toFixed(2) || '52'}%
              </div>

              <div className="capstan-buttons d-flex justify-content-center gap-2">
                <Button size="sm">▲</Button>
                <Button size="sm">▼</Button>
              </div>
            </div>
          </Card>
        </Col>

        {/* = LASER = */}
        <Col md={2}>
          <Card className="panel laser-mini h-100">
            <div className="panel-title">LASER</div>

            <div className="setact-bar set">
              SET {machineLive.DiameterSetValue.toFixed(2) || '5.00'} mm
            </div>

            <div className="setact-bar act">
              ACT {machineLive.ActualDiameter.toFixed(2) || '0.00'} mm
            </div>

            <div
              className={`laser-switch ${
                machineLive.DiameterOnOff ? 'on' : 'off'
              }`}
            >
              {machineLive.DiameterOnOff ? 'ON' : 'OFF'}
            </div>
          </Card>
        </Col>

        {/* = HEATING = */}
        <Col md={3}>
          <Card className="panel heating-mini h-100">
            <div className="panel-title">HEATING</div>

            <div className="setact-bar set">
              SET {machineLive.Set_temp || '70'} °C
            </div>

            <div className="setact-bar act">
              ACT {machineLive.Actual_Temp_Real.toFixed(2) || '40'} °C
            </div>

            <div
              className={`heating-switch ${machineLive.on_off ? 'on' : 'off'}`}
            >
              {machineLive.on_off ? 'ON' : 'OFF'}
            </div>
          </Card>
        </Col>
      </Row>

      {/* ================= BOTTOM ================= */}
      <Row className="g-2 mt-2">
        {/* E75 */}
        <Col md={3}>
          <Card className="panel extruder-mini h-100">
            <div className="panel-title">E75 EXTRUDER</div>

            <div className="extruder-col">
              <span>Current</span>
              <b>{machineLive.E75_MotorCurrentValue.toFixed(2) || '0'} A</b>
              <span>RPM</span>
              <b>{machineLive.E75_MotorRpmValue.toFixed(2) || '0'}</b>

              <div
                className={`mini-switch ${
                  machineLive.E75_ExtruderOnOff ? 'on' : 'off'
                }`}
              >
                {machineLive.E75_ExtruderOnOff ? 'ON' : 'OFF'}
              </div>

              <div className="percent-block">
                <b>{machineLive.E75_PercentReferenceValue || '0'}%</b>
                <div>
                  <Button size="sm">▲</Button>
                  <Button size="sm" className="ms-1">
                    ▼
                  </Button>
                </div>
              </div>
            </div>
          </Card>
        </Col>

        {/* E45 */}
        <Col md={3}>
          <Card className="panel extruder-mini h-100">
            <div className="panel-title">E45 EXTRUDER</div>

            <div className="extruder-col">
              <span>Current</span>
              <b>{machineLive.E45_MotorCurrentValue || '0'} A</b>
              <span>RPM</span>
              <b>{machineLive.E45_MotorRpmValue || '0'}</b>

              <div
                className={`mini-switch ${
                  machineLive.E45_ExtruderOnOff ? 'on' : 'off'
                }`}
              >
                {machineLive.E45_ExtruderOnOff ? 'ON' : 'OFF'}
              </div>

              <div className="percent-block">
                <b>{machineLive.E45_PercentReferenceValue || '0'}%</b>
                <div>
                  <Button size="sm">▲</Button>
                  <Button size="sm" className="ms-1">
                    ▼
                  </Button>
                </div>
              </div>
            </div>
          </Card>
        </Col>

        {/* SPARK */}
        <Col md={6}>
          <Card className="panel spark-pumps-mini h-100">
            <div className="panel-title">SPARK TESTER</div>

            <div className="spark-row">
              <span>SET</span>
              <b>{machineLive.SparkSetKv || '0'} kV</b>
            </div>
            <div className="spark-row">
              <span>ACT</span>
              <b>{machineLive.SparkActualKv || '0'} kV</b>
            </div>
            <div className="spark-row">
              <span>FAULT</span>
              <b>{machineLive.SparkStatus || '0'}</b>
            </div>
            <div className="spark-row">
              <span>PIECES</span>
              <b>{machineLive.SparkPieces || '0'}</b>
            </div>

            <Button size="sm" className="spark-reset w-100 mt-2">
              RESET
            </Button>

            <Row className="g-1 mt-2">
              <Col>
                <Pump label="Vacuum" on={machineLive.vacuum} />
              </Col>
              <Col>
                <Pump label="Water" on={machineLive.water} />
              </Col>
              <Col>
                <Pump label="Dryer" on={machineLive.dryer} />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      {/* ================= MENU ================= */}
      <div className="l75-menu mt-3">
        {[
          { label: '🏠', page: 'HOME' },
          { label: 'E75', page: 'E75' },
          { label: 'E45', page: 'E45' },
          { label: 'E75 COLOR PAGE', page: 'E75Color' },
          { label: 'E45 COLOR PAGE', page: 'E45Color' },
          { label: '🛠', page: 'MeterPage' },
          { label: '⚠', page: 'AlarmPage' }
        ].map((btn, i) => (
          <Button
            key={i}
            className={`menu-icon ${btn.label === '⚠' ? 'warn' : ''}`}
            onClick={() => setPage(btn.page)}
          >
            {btn.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

function SparkRow({ label, value }) {
  return (
    <div className="spark-row">
      <span>{label}</span>
      <span>{value}</span>
    </div>
  );
}

function Pump({ label, on }) {
  return (
    <Button className={`pump-btn ${on ? 'on' : 'off'} w-100`}>{label}</Button>
  );
}

export default L75Hmi;
